import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import {withStyles} from "@material-ui/core/styles";

const styles = {
	root: {
		fontWeight: 400,
		fontFamily: 'futura-pt, sans-serif'
	},
	underline: {
		'&:hover::before': {
			borderBottom: '1px solid #666 !important'
		},
	}
};

class ContactFormInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isTouched: false
		};
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e) {
		this.setState({isTouched: true});
		this.props.onChange(e);
	}

	render() {
		const {classes} = this.props;
		return (
			<TextField fullWidth
			           autoComplete='off'
			           error={this.state.isTouched && !this.props.isValid}
			           required={this.props.required}
			           InputProps={{classes: {root: classes.root, underline: classes.underline}}}
				// eslint-disable-next-line
				       inputProps={{pattern: this.props.pattern}}
				       InputLabelProps={{classes: {root: classes.root}}}
				       FormHelperTextProps={{classes: {root: classes.root}}}
				       type={this.props.type}
				       name={this.props.name}
				       label={this.props.label}
				       onChange={this.handleChange}
				       helperText={this.state.isTouched && !this.props.isValid ? this.props.errorMessage : ''}
				       margin='normal'/>
		);
	}
}

export default withStyles(styles)(ContactFormInput);